import React from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  EmailIcon,
} from "react-share"

const ShareButtons = (props) => {
  let buttons = []
  let url = `https://app.etr.ai${props.articleSlug}`

  if (props.linkedin) {
    buttons.push({
      component: LinkedinShareButton,
      icon: LinkedinIcon,
      name: "LinkedIn",
    })
  }

  if (props.twitter) {
    buttons.push({
      component: TwitterShareButton,
      icon: TwitterIcon,
      name: "Twitter",
      props: {
        title: props.title,
      },
    })
  }

  if (props.email) {
    buttons.push({
      component: EmailShareButton,
      icon: EmailIcon,
      name: "Email",
      props: {
        subject: props.title,
        body: props.message ? `${props.message}: ${url}` : undefined,
      },
    })
  }

  if (props.facebook) {
    buttons.push({
      component: FacebookShareButton,
      icon: FacebookIcon,
      name: "Facebook",
    })
  }

  const trackClick = (platform) => {
    props.trackEvent("Shared Post", {
      article: props.articleSlug,
      via: platform,
    })
  }

  return (
    <div className="share-buttons">
      {buttons.map((button, i) => {
        const ButtonComponent = button.component
        const ButtonIcon = button.icon
        const buttonProps = button.props || {}
        return (
          <div
            key={i}
            className="share-button-item"
            title={`Share via ${button.name}`}
            onClick={(_) => trackClick(button.name)}
          >
            <ButtonComponent
              url={url} // we can't make this an environment variable because these APIs don't work with non-prod urls.
              {...buttonProps}
            >
              <ButtonIcon size={props.size || 32} />
            </ButtonComponent>
          </div>
        )
      })}
    </div>
  )
}

ShareButtons.propTypes = {
  trackEvent: PropTypes.func,
  articleSlug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  facebook: PropTypes.bool,
  linkedin: PropTypes.bool,
  twitter: PropTypes.bool,
  email: PropTypes.bool,
  size: PropTypes.number,
}

ShareButtons.defaultProps = {
  trackEvent: () => {},
  article: "",
  title: "",
  message: "",
  facebook: true,
  linkedin: true,
  twitter: true,
  email: true,
  size: 32,
}

export default ShareButtons
